// extracted by mini-css-extract-plugin
export default {"imageWrapper":"GK-z","twoColumnImage":"HK-z"};